import React, { createContext, PropsWithChildren, useContext, useState } from 'react';

interface SummaryPageContextType {
  isTermsOfServiceModalOpen: boolean;
  setIsTermsOfServiceModalOpen: (isTermsOfServiceModalOpen: boolean) => void;
  apiErrors: unknown | null;
  setApiErrors: (errors: unknown | null) => void;
}

const SummaryPageContext = createContext({} as SummaryPageContextType);

export const SummaryPageProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const [isTermsOfServiceModalOpen, setIsTermsOfServiceModalOpen] = useState<boolean>(false);
  const [apiErrors, setApiErrors] = useState<unknown | null>(null);

  return (
    <SummaryPageContext.Provider
      value={{ isTermsOfServiceModalOpen, setIsTermsOfServiceModalOpen, apiErrors, setApiErrors }}
    >
      {children}
    </SummaryPageContext.Provider>
  );
};

const useSummaryPageContext = () => useContext(SummaryPageContext);

export default useSummaryPageContext;
